import React from 'react'
import { connect } from 'react-redux'
import IOSMotionOrientationPrompt from '../components/IOSMotionOrientationPrompt'
import { getEnv } from 'aria-viewer/utils/environment'
import getBool from 'aria-viewer/utils/getBool'
import compose from 'recompose/compose'
import { setGyroscopEnabled } from 'aria-viewer/device/deviceActions'
import { setPosition } from 'aria-viewer/players/panoplayer/actions/panoramaActions'

const enableGyroNotification = getBool(getEnv('REACT_APP_ENABLE_GYRO_NOTIFICATION'))

const getPanoPlayer = state => _ => state.getIn(['panorama', 'player'])

const mapStateToProps = state => ({
    isDeviceIOS: state.getIn(['device', 'isDeviceIOS']),
    isDeviceTablet: state.getIn(['device', 'isDeviceTablet']),
    isGyroscopeEnabled: state.getIn(['device', 'isGyroscopeEnabled']),
    getPanoPlayer: getPanoPlayer(state),
})

const mapDispatchToProps = dispatch => ({
    setGyroscopEnabled: enabled => {
        dispatch(setGyroscopEnabled(enabled))
    },

    setPosition: ({ lat = 0, lon = 0 }) => {
        dispatch(
            setPosition({
                lat,
                lon,
            })
        )
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,

    onPromptWillShow: _ => {
        const { isDeviceIOS, isDeviceTablet } = stateProps

        // For iPad strangely enough setting the application div position style to fixed is required to
        // work well with sweetalert library
        if (isDeviceIOS && isDeviceTablet) document.getElementById('application').style.position = 'fixed'
    },

    onDevicePermissionGranted: isPermissionGranted => {
        if (isPermissionGranted) dispatchProps.setGyroscopEnabled(true)
    },

    onMotionOrientationPromptLoaded: _ => {
        const { isDeviceIOS, isDeviceTablet, getPanoPlayer } = stateProps

        // Undo the position fixed workaround
        if (isDeviceIOS && isDeviceTablet) document.getElementById('application').style.position = null

        const player = getPanoPlayer()
        let cameraOptions

        if (player) cameraOptions = player.getCameraOptions()

        dispatchProps.setGyroscopEnabled(false)
        dispatchProps.setPosition({ lat: 0, lon: 0 })

        if (player)
            // Keep autorotate the same prior to setPosition called. As setPosition turns off auto rotate.
            player.setAutoRotate(cameraOptions.autoRotate, cameraOptions.autoRotateSpeed)
    },
})

const shouldRender = Component => ({ isDeviceIOS, isGyroscopeEnabled, ...props }) =>
    isDeviceIOS && enableGyroNotification && isGyroscopeEnabled ? <Component {...props} /> : null

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    ),
    shouldRender
)(IOSMotionOrientationPrompt)
